import { Space } from "@/atoms"
import { Remediation } from "@/icons"
import { Heading } from "@/molecules/Heading"
import { InformationPopover } from "@/molecules/InformationPopover"

import type { RemediationHeaderProps } from "./RemediationHeader.types"

import styles from "./RemediationHeader.module.scss"

export const RemediationHeader = ({ t, tKey }: RemediationHeaderProps) => {
  return (
    <Space inline>
      <Remediation className={styles.remediationTitleIcon} />
      <Space orientation="vertical" size={0}>
        <Space size={4} inline>
          <Heading level={5} title={t(`general.kodemRemediation`)} />
          <InformationPopover.Popover
            content={
              <InformationPopover.CommonTemplate>
                {t(`${tKey}kodemRemediationPopover`)}
              </InformationPopover.CommonTemplate>
            }
          />
        </Space>
      </Space>
    </Space>
  )
}
